
export const DefaultTeam = {
	id: 0,
	teamName: 'NHL',
	teamClass: 'team-0',
}

export const TeamMap = [
	DefaultTeam,
	{
		id: 24,
		teamName: 'Anaheim Ducks',
		teamClass: 'team-24',
	},
	{
		id: 53,
		teamName: 'Arizona Coyotes',
		teamClass: 'team-53',
	},
	{
		id: 6,
		teamName: 'Boston Bruins',
		teamClass: 'team-6',
	},
	{
		id: 7,
		teamName: 'Buffalo Sabres',
		teamClass: 'team-7',
	},
	{
		id: 20,
		teamName: 'Calgary Flames',
		teamClass: 'team-20',
	},
	{
		id: 12,
		teamName: 'Carolina Hurricanes',
		teamClass: 'team-12',
	},
	{
		id: 16,
		teamName: 'Chicago Blackhawks',
		teamClass: 'team-16',
	},
	{
		id: 21,
		teamName: 'Colorado Avalanche',
		teamClass: 'team-21',
	},
	{
		id: 29,
		teamName: 'Columbus Blue Jackets',
		teamClass: 'team-29',
	},
	{
		id: 25,
		teamName: 'Dallas Stars',
		teamClass: 'team-25',
	},
	{
		id: 17,
		teamName: 'Detroit Red Wings',
		teamClass: 'team-17',
	},
	{
		id: 22,
		teamName: 'Edmonton Oilers',
		teamClass: 'team-22',
	},
	{
		id: 13,
		teamName: 'Florida Panthers',
		teamClass: 'team-13',
	},
	{
		id: 26,
		teamName: 'Los Angeles Kings',
		teamClass: 'team-26',
	},
	{
		id: 30,
		teamName: 'Minnesota Wild',
		teamClass: 'team-30',
	},
	{
		id: 8,
		teamName: 'Montreal Canadiens',
		teamClass: 'team-8',
	},
	{
		id: 18,
		teamName: 'Nashville Predators',
		teamClass: 'team-18',
	},
	{
		id: 1,
		teamName: 'New Jersey Devils',
		teamClass: 'team-1',
	},
	{
		id: 2,
		teamName: 'New York Islanders',
		teamClass: 'team-2',
	},
	{
		id: 3,
		teamName: 'New York Rangers',
		teamClass: 'team-3',
	},
	{
		id: 9,
		teamName: 'Ottawa Senators',
		teamClass: 'team-9',
	},
	{
		id: 4,
		teamName: 'Philadelphia Flyers',
		teamClass: 'team-4',
	},
	{
		id: 5,
		teamName: 'Pittsburgh Penguins',
		teamClass: 'team-5',
	},
	{
		id: 28,
		teamName: 'San Jose Sharks',
		teamClass: 'team-28',
	},
	{
		id: 55,
		teamName: 'Seattle Kraken',
		teamClass: 'team-55',
	},
	{
		id: 19,
		teamName: 'St. Louis Blues',
		teamClass: 'team-19',
	},
	{
		id: 14,
		teamName: 'Tampa Bay Lightning',
		teamClass: 'team-14',
	},
	{
		id: 10,
		teamName: 'Toronto Maple Leafs',
		teamClass: 'team-10',
	},
	{
		id: 23,
		teamName: 'Vancouver Canucks',
		teamClass: 'team-23',
	},
	{
		id: 54,
		teamName: 'Vegas Golden Knights',
		teamClass: 'team-54',
	},
	{
		id: 15,
		teamName: 'Washington Capitals',
		teamClass: 'team-15',
	},
	{
		id: 52,
		teamName: 'Winnipeg Jets',
		teamClass: 'team-52',
	},
];
